/* eslint-disable react/prop-types */
import React, { Component } from "react";
import styled from "styled-components";
import Icon from "@material-ui/core/Icon";
import List from "@material-ui/core/List";
import NoiseControlOffOutlinedIcon from "@mui/icons-material/NoiseControlOffOutlined";
import Collapse from "@material-ui/core/Collapse";
import { MenuItemLink } from "react-admin";

const MenuItem = styled(MenuItemLink)`
  color: black !important;
`;

class MyMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleClick(type) {
    this.setState({ [type]: !this.state[type] });
  }

  render() {
    const styleIcon = { fontSize: "14px", paddingLeft: "5px" };

    return (
      <>
        <MenuItem
          leftIcon={
            this.state.cycles ? (
              <Icon style={{ color: "gray" }}>data_usage</Icon>
            ) : (
              <Icon>data_usage</Icon>
            )
          }
          primaryText="Ciclos"
          to="#"
          onClick={() => this.handleClick("cycles")}
        />
        <Collapse in={this.state.cycles} timeout="auto" unmountOnExit>
          <MenuItemLink
            to="/cycles"
            primaryText="Ciclos"
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/orders"
            primaryText="Pedidos"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/ads"
            primaryText="Anúncios"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/surveys"
            primaryText="Pesquisas"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/download/cycle"
            primaryText="Baixar XMLs"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/cycles-logistics-send-history"
            primaryText="Pedidos enviados"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/orders/nfe-uploads"
            primaryText="Importar Nota Fiscal"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/consolidated-delivered-orders"
            primaryText="Integração CRM Farma"
            onClick={this.props.onMenuClick}
          />
        </Collapse>

        <MenuItem
          leftIcon={
            this.state.configs ? (
              <Icon style={{ color: "gray" }}>settings</Icon>
            ) : (
              <Icon>settings</Icon>
            )
          }
          primaryText="Configurações"
          to="#"
          onClick={() => this.handleClick("configs")}
        />
        <Collapse in={this.state.configs} timeout="auto" unmountOnExit>
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/groups"
            primaryText="Grupos"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/labs"
            primaryText="Laboratórios"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/panels"
            primaryText="Painel"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/projects"
            primaryText="Projetos"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/samples"
            primaryText="Amostras"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/kits"
            primaryText="Kits"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/kitImport"
            primaryText="Importação de kit"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/sectors"
            primaryText="Setores"
            onClick={this.props.onMenuClick}
          />
        </Collapse>

        <MenuItem
          leftIcon={
            this.state.users ? (
              <Icon style={{ color: "gray" }}>people_alt_rounded</Icon>
            ) : (
              <Icon>people_alt_rounded</Icon>
            )
          }
          primaryText="Usuários"
          to="#"
          onClick={() => this.handleClick("users")}
        />
        <Collapse in={this.state.users} timeout="auto" unmountOnExit>
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/users"
            primaryText="Usuários"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/type-users"
            primaryText="Tipos"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/representatives"
            primaryText="Representantes"
            onClick={this.props.onMenuClick}
          />
          <MenuItemLink
            leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
            to="/addresses"
            primaryText="Endereços"
            onClick={this.props.onMenuClick}
          />
        </Collapse>

        <MenuItem
          leftIcon={
            this.state.interactions ? (
              <Icon style={{ color: "gray" }}>question_answer</Icon>
            ) : (
              <Icon>question_answer</Icon>
            )
          }
          primaryText="Interações"
          to="#"
          onClick={() => this.handleClick("interactions")}
        />
        <Collapse in={this.state.interactions} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <MenuItemLink
              leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
              to="/feedbacks"
              primaryText="Feedbacks"
              onClick={this.props.onMenuClick}
            />
            <MenuItemLink
              leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
              to="/answers"
              primaryText="Respostas"
              onClick={this.props.onMenuClick}
            />
            <MenuItemLink
              leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
              to="/messages"
              primaryText="Mensagens"
              onClick={this.props.onMenuClick}
            />
            <MenuItemLink
              leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
              to="/users-with-confirmed-box"
              primaryText="Entregas Confirmadas"
              onClick={this.props.onMenuClick}
            />
            <MenuItemLink
              leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
              to="/reviews"
              primaryText="Avaliações"
              onClick={this.props.onMenuClick}
            />

            <MenuItem
              leftIcon={
                this.state.samples ? (
                  <Icon style={{ color: "gray" }}>send</Icon>
                ) : (
                  <Icon>send</Icon>
                )
              }
              primaryText="Envio de Amostras"
              to="#"
              onClick={() => this.handleClick("samples")}
            />
            <Collapse in={this.state.samples} timeout="auto" unmountOnExit>
              <MenuItemLink
                leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
                to="/opt-in-users"
                primaryText="Autorizado"
                onClick={this.props.onMenuClick}
              />
              <MenuItemLink
                leftIcon={<NoiseControlOffOutlinedIcon sx={styleIcon} />}
                to="/opt-out-users"
                primaryText="Recusado"
                onClick={this.props.onMenuClick}
              />
            </Collapse>
          </List>
        </Collapse>
      </>
    );
  }
}

export default MyMenu;